import { render, staticRenderFns } from "./logo-layer.vue?vue&type=template&id=9d5c272e&"
import script from "./logo-layer.vue?vue&type=script&lang=js&"
export * from "./logo-layer.vue?vue&type=script&lang=js&"
import style0 from "./logo-layer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports